module.exports = __webpack_public_path__ + "static/media/landing_bottom_background.a5ebc541.png";